import HeartLoader from '@monofront/design-system/components/HeartLoader';
import ProductsSearchResult from '@components/ProductsSearchResult';
import { useState } from 'react';
import { useAuthentication } from '@context/businessContainer';
import { useTranslations } from 'next-intl';
import { useFrequentlyBoughtProducts } from '@hooks/businessContainer';
import { InstantSearch } from 'react-instantsearch-core';
import { searchClient } from '@services/businessContainer';
import {
  generateBaseProductIndexName,
  getChannelFromLocale,
} from '@monofront/business/utils';
import getConfig from 'next/config';
import { useRouter } from 'next/router';

const {
  publicRuntimeConfig: { algoliaConfig },
} = getConfig();

export const LastOrders: React.FC = () => {
  const [isSortFrequentlyBought, setIsSortFrequentlyBought] = useState(true);
  const { customSort, customerFilter, frequentlyBoughtProducts } =
    useFrequentlyBoughtProducts({
      filterUnavailableProducts: false,
      limit: isSortFrequentlyBought ? 100 : undefined,
    });
  const { isLoading: isLoadingAuth } = useAuthentication();
  const { locale } = useRouter();
  const baseIndexName = generateBaseProductIndexName({
    environment: algoliaConfig.environment,
    app: false,
    channel: getChannelFromLocale(locale),
  });

  const tAccount = useTranslations('Account');

  if (isLoadingAuth) {
    return <HeartLoader />;
  }

  if (frequentlyBoughtProducts?.length === 0) {
    return <p>{tAccount('noOrders')}</p>;
  }

  return (
    <InstantSearch
      indexName={baseIndexName}
      searchClient={searchClient}
      insights
      future={{
        preserveSharedStateOnUnmount: true,
      }}
    >
      <ProductsSearchResult
        filters={customerFilter}
        setIsCustomSort={setIsSortFrequentlyBought}
        customSort={isSortFrequentlyBought ? customSort : undefined}
        hitsPerPage={isSortFrequentlyBought ? 100 : 40}
      />
    </InstantSearch>
  );
};
